// Server URL configuration for different environments
// You can override this by setting REACT_APP_SERVER_URL in your .env file

const getServerUrl = () => {
  // Check if REACT_APP_SERVER_URL is set in environment variables
  if (process.env.REACT_APP_SERVER_URL) {
    return process.env.REACT_APP_SERVER_URL;
  }
  
  // Fallback to localhost for development
  return 'http://localhost:8081';
};

export const SERVER_URL = getServerUrl();

// Export default for convenience
export default {
  SERVER_URL,
};
